'use strict'

export const IS_EVENTS_JSON_LOADED = 'isEventsJsonLoaded'
export const EVENTS_JSON = 'eventsJson'
